import axios from 'axios';
// import { getToken } from '@iso/lib/helpers/utility';
import { put } from 'redux-saga/effects';
import actions from '../../redux/auth/actions';
import {verify} from "jsonwebtoken";
// const history = createBrowserHistory();
// const fakeApiCall = false; // auth0 or express JWT
const timeout = 60000;
const apiUrl = process.env.REACT_APP_API_URL;
// const systemId = process.env.REACT_APP_SYSTEM_ID;

const bearer = process.env.REACT_APP_RES_API_BEARER;
const credentials = new Buffer(bearer).toString('base64');
const authHeader = `Basic ${credentials}`;

let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': authHeader,
};

export function* AuthorizedGet(uri, data, page, sort, token) {
    // this.checkToken();

    // const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
    // if (token) {
    headers = {
        ...headers,
        authorization: authHeader,
    };
    // }
    if (page) {
        headers = {
            ...headers,
            Range: `${page.page || 1}-${page.limit || 10}`,
        };
        data.page = `${page.page || 1}-${page.limit || 10}`;
    }
    if (!sort) {
        sort = {
            sort: 'asc',
            sortBy: 'createdAt',
        };
    }
    const params = data ? toParams(data) : '';
    const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
    return yield fetch(`${apiUrl}${uri}?${params}${sortField}`, {
        headers: headers,
        method: 'GET',
    });
}

export function* post(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}

export function* AuthorizedPost(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}
export function* postBlob(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
        responseType: 'blob',
    });
}
export function* AuthorizedPut(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'PUT',
        data,
    });
}

export function* DELETE(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'DELETE',
        data,
    });
}

function toParams(data) {
    const url = Object.keys(data).map((k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    }).join('&');
    return url;
}

function* forbidden() {
    yield localStorage.setItem('forbidToken', 1);
    yield put({
        type: actions.CHECK_AUTHORIZATION,
    });
}

export function* fetch(url, options) {
    // try {
    const result = yield axios.request({
        ...options,
        url,
        baseURL: apiUrl,
        timeout: timeout,
        headers: headers
    }).then((res) => {
        return res;
    }).catch((error) => {
        return error
    })
    try {
        const response = result.status ? result : result.response ? result.response : null;
        if (!response) return null;
        if (response.status === 401 || response.status === 403) return yield forbidden()
        if (!response.data || response.data instanceof Blob) return response;

        // Verify response data
        const { payload } = verify(response.data, process.env.REACT_APP_ENV_KEY);
        if (typeof payload === 'string') {
            try {
                const parsedPayload = JSON.parse(payload);
                return {...response, data: parsedPayload };
            } catch (e) {
                // Detect base64 the convert to blob
                return {...response, data: payload };
            }
        }
        return {...response, data: payload };
    } catch (error) {
        return error
    }
}